var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66653 3V1C2.66653 0.631814 2.96501 0.333334 3.3332 0.333334H11.3332C11.7014 0.333334 11.9999 0.631814 11.9999 1V10.3333C11.9999 10.7015 11.7014 11 11.3332 11H9.3332V12.9994C9.3332 13.3679 9.03327 13.6667 8.662 13.6667H0.671107C0.300393 13.6667 0 13.3703 0 12.9994L0.0017333 3.66725C0.00179997 3.29874 0.30176 3 0.672947 3H2.66653ZM1.33495 4.33333L1.33346 12.3333H7.99987V4.33333H1.33495ZM3.99987 3H9.3332V9.66667H10.6665V1.66667H3.99987V3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector8);
export default __webpack_public_path__ + "static/media/Vector (8).23ffb9861dcf17b52bb2931188833ac4.svg";
export { ForwardRef as ReactComponent };